<!-- Hero Section -->
<section id="hero">
  <app-accounting-hero></app-accounting-hero>
</section>

<!-- Overview Section -->
<section id="overview">
  <app-accounting-overview></app-accounting-overview>
</section>

<!-- Features Section -->
<section id="features">
  <app-accounting-features></app-accounting-features>
</section>
